<!--
  2026-09-15
  改动点：企业会员套餐由独立卡片改为权益对比表
  说明：权益单元格为示意文案，后续按实际内容替换；开通/定制按钮沿用页面原订阅逻辑
  2026-09-15
  改动点：表头左右上圆角；套餐列 hover 浮起；第一列会员权益子列增加竖向分割线
  2026-09-15
  改动点：表头与选中列每个单元格改为上到下黄色渐变，不再使用整列一条渐变
  2026-09-15
  改动点：选中列单元格黄色调浅；会员权益右侧子列文字居中
  2026-09-15
  改动点：按企业会员对照表填充权益文案；保留定制会员列；包月年付价格按月展示
  2026-09-15
  改动点：按对照表补全授权场景完整行名、其他说明与底部备注行
  2026-09-15
  改动点：表格左右加边框；左侧分组列加粗加大；单元格内边距加倍
  2026-09-15
  改动点：选中表头改为向上延伸色块，避免上浮后与首行出现空白缝
  2026-09-16
  改动点：左右边框改到圆角单元格上，避免容器直角边框穿出圆角
  2026-09-16
  改动点：边框色统一为 #e8ddd3；每个单元格显示横竖分割线
  2026-09-16
  改动点：对号绿色加大、叉号红色加大
  2026-09-16
  改动点：授权场景、特殊授权行名左对齐
  2026-09-16
  改动点：定制会员价格格增加「联系客服」文案，按钮改为立即咨询
  2026-09-16
  改动点：行名与授权期限等子描述改为问号 tooltip
  2026-09-16
  改动点：滚动时表头与价格行吸顶；价格行从分组跨行中拆出
-->
<template>
  <div
    class="compare-table company-table"
    :style="tableStyle"
    @mouseleave="clearHover"
  >
    <div class="head label-head" @mouseenter="clearHover">企业会员</div>
    <div
      v-for="(item, index) in saleList"
      :key="`company-head-${item.goods_id || index}`"
      class="head pkg-head"
      :class="{ highlight: isHighlight(item), 'is-last': index === saleList.length - 1 }"
      @mouseenter="setHover(item)"
    >{{ item.name }}</div>

    <template v-for="row in flatRows">
      <div
        v-if="row.showGutter"
        :key="`company-gutter-${row.rowKey}`"
        class="gutter"
        :style="{ gridRow: `span ${row.groupSpan}` }"
      >{{ row.groupName }}</div>
      <div
        :key="`company-label-${row.rowKey}`"
        class="feat-cell label-cell"
        :class="{ 'price-cell': row.isPrice, 'price-label': row.spanPriceLabel, 'is-left': isLeftLabelGroup(row) }"
        :style="row.spanPriceLabel ? { gridColumn: '1 / 3' } : null"
      >
        <span class="label-text">
          {{ row.label }}
          <el-tooltip
            v-if="row.desc"
            :content="row.desc"
            placement="top"
            effect="dark"
            popper-class="pkg-help-tooltip"
          >
            <i class="el-icon-question help-icon" @click.stop></i>
          </el-tooltip>
        </span>
      </div>
      <div
        v-for="(item, pIdx) in saleList"
        :key="`company-cell-${row.rowKey}-${item.goods_id || pIdx}`"
        class="feat-cell pkg-cell"
        :class="{ 'price-cell': row.isPrice, highlight: isHighlight(item), 'is-last': pIdx === saleList.length - 1 }"
        @mouseenter="setHover(item)"
      >
        <template v-if="row.isPrice">
          <template v-if="isCustomPackage(item)">
            <div class="current-price">联系客服</div>
            <span class="cta-btn" @click="onSubscribe(item)">立即咨询</span>
          </template>
          <template v-else>
            <div class="current-price">
              <i>¥</i>{{ displayPrice(item) }}<span v-if="priceUnit(item)">{{ priceUnit(item) }}</span>
            </div>
            <span
              class="cta-btn"
              id="lijikaitong"
              data-agl-cvt="7"
              @click="onSubscribe(item)"
            >立即开通</span>
          </template>
        </template>
        <template v-else-if="isHintValue(item, row)">
          <span class="cell-text cell-with-help">
            {{ cellMain(item, row) }}
            <el-tooltip
              :content="cellHint(item, row)"
              placement="top"
              effect="dark"
              popper-class="pkg-help-tooltip"
            >
              <i class="el-icon-question help-icon" @click.stop></i>
            </el-tooltip>
          </span>
        </template>
        <template v-else-if="isMultiValue(item, row)">
          <div
            v-for="(line, lineIdx) in cellValue(item, row)"
            :key="`company-line-${row.rowKey}-${lineIdx}`"
            class="cell-line"
          >{{ line }}</div>
        </template>
        <span v-else class="cell-text" :class="markClass(cellValue(item, row))">{{ cellValue(item, row) }}</span>
      </div>
    </template>
    <div class="table-other" :style="{ gridColumn: `1 / ${saleList.length + 3}` }">其他：如果您正在制作以上未列出的项目或有增加被授权企业数的需求，我们的团队将很乐意为您的需求进行量身定制</div>
    <div class="table-note" :style="{ gridColumn: `1 / ${saleList.length + 3}` }">注：订阅会员可下载全站素材，并在相应会员授权范围内使用，会员产品购买成功后不支持退换和转让，其中图片素材不可用于原创认证及线下渠道。</div>
  </div>
</template>

<script>
export default {
  name: 'CompanyPackageTable',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      hoverId: null,
      // 2026-09-15 原示意行保留，便于回滚
      // featureRows: [
      //   { label: '授权', cell: '文字文字' },
      //   { label: 'VIP音乐授权', cell: '文字文字' },
      //   { label: 'VIP音乐', cell: '文字文字' },
      //   { label: 'VIP音乐授权', cell: '文字文字' },
      //   { label: '音乐授权', cell: '文字文字' }
      // ],
      featureGroups: [
        {
          name: '会员权益',
          rows: [
            { key: 'price', label: '会员价格', isPrice: true },
            {
              key: 'download',
              label: '下载次数',
              values: {
                yearPay: '690次',
                year1: '90次',
                year10: '3600次',
                custom: '海量下载'
              }
            },
            {
              key: 'daily',
              label: '单日下载',
              values: {
                yearPay: '25次/日',
                year1: '20次/日',
                year10: '30次/日',
                custom: '海量下载'
              }
            },
            {
              key: 'allSite',
              label: '畅享全站素材',
              desc: '购买会员后，全站素材可下载和使用，无需额外付费',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            },
            {
              key: 'audience',
              label: '受众数量&视频曝光&企业规模',
              values: { yearPay: '无限制', year1: '无限制', year10: '无限制', custom: '无限制' }
            },
            {
              key: 'companyNum',
              label: '可授权公司数量',
              values: { yearPay: '3家', year1: '1家', year10: '10家', custom: '可定制' }
            },
            {
              key: 'material',
              label: '宣传转载',
              desc: '已激活授权的项目作品可由被授权公司及其相关联公司转载',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            },
            {
              key: 'beneficiaries',
              label: '多设备登录',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            },
            {
              key: 'invoice',
              label: '企业发票',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            },
            {
              key: 'select',
              label: '免费选曲',
              values: {
                yearPay: '人工&AI 选曲',
                year1: '人工&AI 选曲',
                year10: '人工&AI 选曲',
                custom: '人工&AI 选曲'
              }
            }
          ]
        },
        {
          name: '版权保障',
          rows: [
            {
              key: 'term',
              label: '授权期限',
              desc: '随片永久/与订阅服务期限一致（直播/电台FM、课程教育、产品内置、线下场所公播、电商直播）',
              values: {
                yearPay: { text: '随片永久', desc: '订阅服务期内已激活授权的项目作品可在已发表渠道永久保留' },
                year1: { text: '随片永久', desc: '订阅服务期内已激活授权的项目作品可在已发表渠道永久保留' },
                year10: { text: '随片永久', desc: '订阅服务期内已激活授权的项目作品可在已发表渠道永久保留' },
                custom: { text: '随片永久', desc: '订阅服务期内已激活授权的项目作品可在已发表渠道永久保留' }
              }
            },
            {
              key: 'area',
              label: '授权地域',
              values: { yearPay: '全球', year1: '全球', year10: '全球', custom: '全球' }
            },
            {
              key: 'certificate',
              label: '正版授权书',
              desc: '每个项目作品可在订阅服务期内独立开具授权书',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            },
            {
              key: 'agreement',
              label: '授权协议',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            }
          ]
        },
        {
          name: '授权场景',
          rows: [
            {
              key: 'ads',
              label: '商业广告/宣传片：发布于各类互联网上、移动端、电视、电商平台和线下的广告等（图片素材不能用于电视及线下广告）',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            },
            {
              key: 'mediaCn',
              label: '国内自媒体平台：微信公众号、视频号、微博、哔哩哔哩、斗鱼、抖音、快手等',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            },
            {
              key: 'mediaOver',
              label: '海外自媒体平台：YouTube、Facebook、TikTok、Twitter、Instagram等',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            },
            {
              key: 'live',
              label: '直播/电台FM：广播剧、有声书、电台FM、网络节目、网络直播节目等',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            },
            {
              key: 'course',
              label: '课程教育：培训机构、公开课程、网络直播课程、在线录播课程、教育平台等付费课程（图片素材不可使用）',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            },
            {
              key: 'product',
              label: '产品内置：企业制作小程序、H5、小游戏；官网、网站装饰、APP、软件、开机动画、落地物料、VR场景、游戏CG、航拍、导视系统等',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            },
            {
              key: 'offline',
              label: '线下场所公播：商超、餐饮、咖啡厅、影院、酒吧、年会、展会、发布会等线下场所作为背景播放（图片素材不可使用）',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            },
            {
              key: 'office',
              label: '办公用途：企业、事业、政府机关、团体、学校、医院等单位内部宣传或内部活动使用；VI设计、营销策划方案、商业提案、项目计划书、年度报告等配图（仅图片素材可以使用）',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            },
            {
              key: 'shop',
              label: '电商店铺用途：淘宝、京东、天猫、拼多多等第三方电商平台背景视频音乐、装饰配图',
              values: { yearPay: '✓', year1: '✓', year10: '✓', custom: '✓' }
            }
          ]
        },
        {
          name: '特殊授权',
          rows: [
            {
              key: 'film',
              label: '制作成电影、电视剧、综艺以及 NFT 进行使用',
              values: { yearPay: '×', year1: '×', year10: '×', custom: '×' }
            },
            {
              key: 'sublicense',
              label: '进行转授权、原创认证；用于商标、logo 或实体印刷',
              values: { yearPay: '×', year1: '×', year10: '×', custom: '×' }
            },
            {
              key: 'sensitive',
              label: '肖像权敏感授权：医疗、药物、保健品、养生、美容、整形、交友等行业',
              values: { yearPay: '×', year1: '×', year10: '×', custom: '×' }
            }
          ]
        }
      ]
    }
  },
  computed: {
    saleList() {
      return this.list || []
    },
    flatRows() {
      const rows = []
      this.featureGroups.forEach((group) => {
        const bodyRows = group.rows.filter((row) => !row.isPrice)
        group.rows.forEach((row) => {
          if (row.isPrice) {
            rows.push({
              ...row,
              groupName: group.name,
              showGutter: false,
              spanPriceLabel: true,
              groupSpan: 1,
              rowKey: `${group.name}-${row.key}`
            })
            return
          }
          const bodyIdx = bodyRows.indexOf(row)
          rows.push({
            ...row,
            groupName: group.name,
            showGutter: bodyIdx === 0,
            groupSpan: bodyRows.length,
            rowKey: `${group.name}-${row.key}`
          })
        })
      })
      return rows
    },
    tableStyle() {
      const count = this.saleList.length || 1
      return {
        gridTemplateColumns: `40px minmax(200px, 240px) repeat(${count}, minmax(0, 1fr))`
      }
    },
    defaultHighlightId() {
      const yearPayItem = this.saleList.find((item) => item.is_sum == 3)
      if (yearPayItem) return yearPayItem.goods_id
      const firstSale = this.saleList.find((item) => !this.isCustomPackage(item))
      return firstSale ? firstSale.goods_id : null
    },
    activeHighlightId() {
      return this.hoverId != null ? this.hoverId : this.defaultHighlightId
    }
  },
  methods: {
    isCustomPackage(item) {
      if (!item) return false
      if (item.name === '定制会员') return true
      const price = item.is_sum == 3 ? Number(item.per_price) : Number(item.price)
      return price == 9999
    },
    packageKind(item) {
      if (this.isCustomPackage(item)) return 'custom'
      if (item.is_sum == 3) return 'yearPay'
      const cert = Number(item.cert_num)
      if (cert == 1) return 'year1'
      if (cert == 10) return 'year10'
      const price = Number(item.price)
      if (price <= 500) return 'year1'
      return 'year10'
    },
    cellValue(item, row) {
      const kind = this.packageKind(item)
      if (!row.values) return ''
      if (row.values[kind] != null) return row.values[kind]
      return row.values.year1 != null ? row.values.year1 : ''
    },
    isMultiValue(item, row) {
      return Array.isArray(this.cellValue(item, row))
    },
    isHintValue(item, row) {
      const value = this.cellValue(item, row)
      return value && typeof value === 'object' && !Array.isArray(value) && value.text
    },
    cellMain(item, row) {
      return this.cellValue(item, row).text
    },
    cellHint(item, row) {
      return this.cellValue(item, row).desc
    },
    markClass(value) {
      if (value === '✓') return 'mark-yes'
      if (value === '×') return 'mark-no'
      return ''
    },
    isLeftLabelGroup(row) {
      return row.groupName === '授权场景' || row.groupName === '特殊授权'
    },
    setHover(item) {
      this.hoverId = item.goods_id
    },
    clearHover() {
      this.hoverId = null
    },
    isHighlight(item) {
      return item && item.goods_id === this.activeHighlightId
    },
    displayPrice(item) {
      if (item.is_sum == 3) return Number(item.per_price)
      return Number(item.price)
    },
    priceUnit(item) {
      return this.packageKind(item) === 'yearPay' ? '/月' : ''
    },
    onSubscribe(item) {
      const payType = (item.is_month == 1 || item.is_sum == 3) ? 'month' : 'pay'
      this.$emit('subscribe', item, payType)
    }
  }
}
</script>

<style lang="scss" scoped>
.compare-table {
  display: grid;
  width: 100%;
  background: transparent;
  overflow: visible;
  padding-top: 10px;
  box-sizing: border-box;
}
.head {
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  background: linear-gradient(180deg, #ffe4c8 0%, #ffd3aa 100%);
  color: #b85c2a;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  line-height: 1.3;
  transition: background 0.15s ease;
  box-sizing: border-box;
  position: sticky;
  top: 60px;
  z-index: 9;
}
.label-head {
  grid-column: 1 / 3;
  border-radius: 16px 0 0 0;
  border-left: 1px solid #e8ddd3;
  border-right: 1px solid #e8ddd3;
}
.pkg-head {
  cursor: pointer;
  border-right: 1px solid #e8ddd3;
  &.is-last:not(.highlight) {
    border-radius: 0 16px 0 0;
  }
  &.highlight {
    border-radius: 0;
    background: linear-gradient(180deg, #ffd7b0 0%, #ffc091 100%);
    box-shadow: 0 6px 12px rgba(255, 156, 92, 0.18);
    z-index: 10;
    &::before {
      content: '';
      position: absolute;
      top: -8px;
      left: 0;
      right: 0;
      height: 8px;
      background: #ffd7b0;
      border-radius: 16px 16px 0 0;
      box-sizing: border-box;
    }
    &.is-last::before {
      border-right: 1px solid #e8ddd3;
    }
  }
}
.gutter {
  display: flex;
  align-items: center;
  justify-content: center;
  writing-mode: vertical-rl;
  letter-spacing: 2px;
  font-size: 13px;
  color: #fc4243;
  font-weight: 700;
  border-left: 1px solid #e8ddd3;
  border-right: 1px solid #e8ddd3;
  border-top: 1px solid #e8ddd3;
  background: #fff;
  box-sizing: border-box;
}
.feat-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #e8ddd3;
  border-right: 1px solid #e8ddd3;
  color: #666;
  font-size: 14px;
  box-sizing: border-box;
  background: #fff;
  padding: 20px 16px;
  min-height: 56px;
  text-align: center;
  line-height: 1.5;
  &.highlight {
    background: linear-gradient(180deg, #fff6ee 0%, #fffdf9 100%);
    position: relative;
    z-index: 1;
  }
}
.label-cell {
  flex-direction: column;
  color: #333;
  &.is-left {
    align-items: flex-start;
    text-align: left;
    .label-text,
    .label-desc {
      text-align: left;
    }
    .label-text {
      align-items: flex-start;
    }
  }
}
.pkg-cell {
  cursor: pointer;
  flex-direction: column;
}
.feat-cell.price-cell {
  min-height: 148px;
  height: auto;
  position: sticky;
  top: 114px;
  z-index: 8;
}
.price-label {
  border-left: 1px solid #e8ddd3;
}
.label-text {
  color: #333;
  font-size: 14px;
  text-align: center;
  display: inline-flex;
  align-items: center;
}
.label-desc {
  margin-top: 4px;
  color: #999;
  font-size: 12px;
  line-height: 1.4;
  text-align: center;
}
.cell-line + .cell-line {
  margin-top: 4px;
  font-size: 12px;
  color: #999;
}
.cell-text {
  white-space: pre-wrap;
  &.mark-yes {
    color: #22c55e;
    font-size: 20px;
    font-weight: 700;
    line-height: 1;
  }
  &.mark-no {
    color: #fc4243;
    font-size: 20px;
    font-weight: 700;
    line-height: 1;
  }
}
.table-other,
.table-note {
  padding: 14px 24px;
  font-size: 13px;
  color: #666;
  line-height: 1.7;
  text-align: left;
  background: #fff;
  border-top: 1px solid #e8ddd3;
  border-left: 1px solid #e8ddd3;
  border-right: 1px solid #e8ddd3;
  box-sizing: border-box;
}
.table-other {
  border-bottom: none;
}
.table-note {
  border-bottom: 1px solid #e8ddd3;
  border-radius: 0 0 16px 16px;
}
.current-price {
  color: #fc4243;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 12px;
  font-family: alipuhuir, PingFang SC, sans-serif;
  i {
    font-style: normal;
    font-size: 16px;
    margin-right: 2px;
  }
  span {
    font-size: 14px;
    font-weight: 500;
    margin-left: 2px;
  }
}
.cta-btn {
  display: inline-block;
  min-width: 88px;
  height: 32px;
  line-height: 32px;
  padding: 0 16px;
  border-radius: 16px;
  background: linear-gradient(135deg, #fe7273 0%, #fc4243 100%);
  color: #fff;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  user-select: none;
}
.cell-with-help {
  display: inline-flex;
  align-items: center;
}
.help-icon {
  margin-left: 4px;
  color: #b0b0b0;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
  line-height: 1;
}
</style>
<style lang="scss">
.pkg-help-tooltip {
  max-width: 320px;
  line-height: 1.6;
}
</style>
